import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-funding-pdf-modal",
  templateUrl: "./funding-pdf-modal.component.html",
  styleUrls: ["./funding-pdf-modal.component.scss"],
})
export class FundingPdfModalComponent implements OnInit {
  @Input() pdfUrl: string;
  @Input() modalTitle: string;
  @Input() closeLabel: string;

  public safePdfUrl: SafeResourceUrl;

  constructor(
    private modalController: ModalController,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if (this.pdfUrl) {
      // view=FitH scales the page to the frame width, so the poster is never clipped on a
      // narrow screen. The viewer's own toolbar stays: it is how a user zooms the PDF.
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.pdfUrl + "#view=FitH&navpanes=0"
      );
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
